module.exports = __webpack_public_path__ + "static/media/popup_desktop.70f40b1e.webp";